<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'cloudServerManager' })"
            >沙盒服务器管理</em
          >
          <label
            ><i class="el-icon-arrow-right"></i>
            {{
              currServers.length ? '升级/续费服务器' : $route.meta.title
            }}</label
          >
        </div>
      </div>
      <div class="content-inner-wrapper">
        <ServerOrder :currServs="currServers" />
      </div>
    </div>
  </div>
</template>
<script>
import ServerOrder from '../../components/serverOrder/pc.vue';
export default {
  components: {
    ServerOrder,
  },
  data() {
    return {
      title: '服务器购买页面',
      currServers: [],
    };
  },
  created() {
    if (this.$route.params.type === 'renew') {
      this.currServers = JSON.parse(localStorage.getItem('renewItems') || '[]');
    }
    console.log('buy.vue created---', this.currServers);
  },
};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
